import { Box, styled } from '@planne-software/uni/mui/material';

export const Wrapper = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  width: '100%',
  borderBottom: `1px solid ${theme.tokens.colors['border-color-neutral-softer']}`,
  paddingBottom: theme.tokens.spacing['spacing-sm'],
  gap: 0,
}));

export const AboveLabel = styled('p')(({ theme }) => ({
  ...theme.tokens.typography['text-sm-medium'],
  margin: 0,
  color: theme.tokens.colors['text-color-neutral-strong'],
}));

export const PriceLine = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'flex-end',
  gap: theme.tokens.spacing['spacing-2xmini'],
}));

export const HeroPrice = styled('p')(({ theme }) => ({
  ...theme.tokens.typography['display-sm-bold'],
  margin: 0,
  color: theme.tokens.colors['text-color-neutral-strongest'],
}));

export const PriceSuffix = styled('p')(({ theme }) => ({
  ...theme.tokens.typography['text-sm-medium'],
  margin: 0,
  color: theme.tokens.colors['text-color-neutral-strongest'],
}));

export const SecondaryLine = styled('p')(({ theme }) => ({
  ...theme.tokens.typography['text-sm-medium'],
  margin: 0,
  color: theme.tokens.colors['text-color-neutral-strongest'],
}));

export const OldPrice = styled('p')(({ theme }) => ({
  ...theme.tokens.typography['text-sm-medium'],
  margin: 0,
  color: theme.tokens.colors['text-color-neutral-soft'],
  textDecoration: 'line-through',
}));

export const OldPriceLine = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.tokens.spacing['spacing-2xmini'],
}));

export const DiscountRow = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.tokens.spacing['spacing-2xmini'],
  flexWrap: 'wrap',
}));

export const DiscountBadge = styled('span')(({ theme }) => ({
  ...theme.tokens.typography['text-xs-semibold'],
  backgroundColor: theme.tokens.colors['fill-color-accent-softest'],
  color: theme.tokens.colors['text-color-accent-stronger'],
  borderRadius: theme.tokens.radius['border-radius-2xs'],
  padding: '0.125rem 0.375rem',
  whiteSpace: 'nowrap',
}));
